import React from 'react';
import { Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody, Button, Box } from '@mui/material';
import { formatDate } from '../../../utils/formatDate';
import { useGet } from '../../../sharedModules/hooks/useQuery';

interface PreviousInspection {
  id: number;
  created_at: string;
  order_no: string;
  technician: string;
}

interface PreviousInspectionsTableProps {
  customerName: string;
  onView: (inspectionId: number) => void;
}

const sectionHeaderSx = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#fff',
  bgcolor: '#3d5a80',
  px: 2,
  py: 1,
  borderRadius: '4px 4px 0 0',
};

const PreviousInspectionsTable: React.FC<PreviousInspectionsTableProps> = ({ customerName, onView }) => {
  const { data } = useGet<PreviousInspection[]>({
    url: '/home_services/inspection_reports/customer_history',
    params: { customer_name: customerName },
    enabled: !!customerName,
  });

  const history = data?.data ?? [];

  if (!history.length) return null;

  return (
    <Paper variant="outlined" sx={{ mb: 3, overflow: 'hidden' }}>
      <Typography sx={sectionHeaderSx}>Previous Home Inspection Reports</Typography>
      <Box sx={{ p: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#f9f9f9' }}>
              <TableCell sx={{ fontWeight: 600, color: '#555' }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#555' }}>Work Order</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#555' }}>Technician</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map((report) => (
              <TableRow key={report.id} hover>
                <TableCell>{formatDate(report.created_at)}</TableCell>
                <TableCell>{report.order_no || '—'}</TableCell>
                <TableCell>{report.technician || '—'}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => onView(report.id)}
                    sx={{ bgcolor: '#3d5a80', '&:hover': { bgcolor: '#2c4460' } }}
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
};

export default PreviousInspectionsTable;
